export default {
  getOne: state => id => state.telefonesuteis.find(item => item.id === id),
}
